import { ContentItem } from '@apptus/esales-api';
import { IQuickSearchResultCollection } from '../../../../types';
import handleFromUrl from '../../../../../../util/handleFromUrl';
import { generateContentTicket } from '../handleTickets';

const mapCollection = (collInResponse: ContentItem, searchTerm?: string): IQuickSearchResultCollection => {
  // Store the ticket in localStorage if we have a search term (autocomplete context)
  if (searchTerm && collInResponse.ticket) {
    generateContentTicket(collInResponse, searchTerm);
  }

  return {
    id: collInResponse.key.toString(),
    handle: handleFromUrl(collInResponse.link),
    title: collInResponse.title,
    url: collInResponse.link,
    ticket: collInResponse.ticket,
    description: collInResponse.description
  };
};

export default mapCollection;
